import React from "react";
import "./App.less";
import Home from "./pages/Home";
export default function App() {
  // if (getPlatformIOS()) {
  //   return <HomeIOS />;
  // }
  return <Home />;
}
